import { createSelector } from 'reselect';

import { getPaging, getTextEditing, mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('magazine');

export const getMagazineArticlesIds = mount((localState, props) => {
  const { queryString, page } = props;
  const pagesForQuery = localState.magazineArticles.byQuery[queryString];

  if(!pagesForQuery) {
    return [];
  }

  const magazineArticlesIds = pagesForQuery.byPage[page];

  if(!magazineArticlesIds) {
    return [];
  }

  return magazineArticlesIds;
});

export const getMagazineArticlesById = mount(localState => localState.magazineArticles.byId);

export const getMagazineArticlesOnFrontPage = createSelector(
  [getMagazineArticlesIds, getMagazineArticlesById],
  (magazineArticlesIds, magazineArticlesById) => {
    return magazineArticlesIds.map(id => {
      return magazineArticlesById[id];
    });
  }
);

export const getMagazineArticlesOnSidebar = createSelector(
  [getMagazineArticlesIds, getMagazineArticlesById],
  (magazineArticlesIds, magazineArticlesById) => {

    return magazineArticlesIds.map(id => {
      return magazineArticlesById[id];
    });
  }
);

export const getMagazineArticle = mount((localState, id) => localState.magazineArticles.byId[id]);

export const getMagazinePaging = mount((localState, key, options) => getPaging(localState.paging[key], options));

export const getMagazineContribute = mount(localState => localState.magazineContribute);

export const getMagazineTextEditing = mount((localState, key) => getTextEditing(localState.textEditing[key]));

export const getMagazineEmojis = mount((localState, key) => localState.emojis[key]);



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/selectors.js
 **/